import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query'
import { getRequest, postRequest, deleteRequest } from 'utils/http'

//Get Users
export const getSponsor = async (current, pageSize, searchQuery) => {
  const response = await getRequest('sponsors', {
    params: {
      page: current,
      pageSize: pageSize,
      searchQuery: searchQuery,
    },
  })

  return {
    data: response.data,
    total: response.total,
  }
}

export const useGetSponsor = (current, pageSize, searchQuery) => {
  return useQuery({
    queryKey: ['sponsors', current, pageSize, searchQuery],
    queryFn: () => getSponsor(current, pageSize, searchQuery),
  })
}

//Create Sponsor
export const createSponsor = async newSponsorData => {
  // Ensure a multipart form is used for file uploads (e.g., logo)
  return postRequest(`sponsors`, newSponsorData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const useCreateSponsor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: params => createSponsor(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['sponsors'])
    },
  })
}

//Update Sponsor
export const updateSponsor = async params => {
  // The FormData object is correctly created in the modal component.
  // We just need to add the _method field here and send it.
  const { id, updatedData } = params
  updatedData.append('_method', 'PUT')

  return postRequest(`sponsors/${id}`, updatedData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const useUpdateSponsor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: params => updateSponsor(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['sponsors'])
    },
  })
}

export const useDeleteSponsor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    // The mutationFn now expects the ID directly, e.g., deleteSponsor(5)
    mutationFn: async id => {
      // Call the delete endpoint with the single ID
      return deleteRequest(`sponsors/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['sponsors'])
    },
  })
}
